import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { DATA_FEED_URL } from 'constants/api/apiServices';

export const INVALIDATION_TAGS = {
  SETUP: 'setup',
  GET_USERS: 'getUsers',
  GET_PRODUCT_REPORT: 'getProductReport',
  GET_PRODUCT_PLAYERS_STATISTICS: 'getProductPlayerStatistics',
  GET_COUNTRIES_REPORT_LIST: 'getCountryByCountryReport',
  GET_MONTHLY_REPORT_LIST: 'getMonthByMonthReport',
  GET_MEDIA_STATISTICS_PRO: 'getMediaStatisticsPro',
  GET_REVENUE_BREAKDOWN_LIST: 'getRevenueBreakdownReport',
  GET_PRODUCT_AFFILIATE_STATISTICS_SUB: 'getProductStatisticsByAffiliateSub',
  GET_PRODUCT_STATISTICS_SUB: 'getProductStatisticsSub',
  GET_PRODUCT_STATISTICS: 'getProductStatistics',
  GET_PRODUCT_STATISTICS_DAILY: 'getProductStatisticsDaily',
  GET_PRODUCT_STATISTICS_DAILY_SUB: 'getProductStatisticsDailySub',
  GET_SUB_AFFILIATE_STATISTICS: 'getSubAffiliateStatistic',
  GET_AGENT_WALLET_INFO_AFTER_TRANSACTION: 'getAgentWalletInfoAfterTransaction',
  GET_PLAYER_WALLET_INFO_AFTER_TRANSACTION: 'getPlayerWalletInfoAfterTransaction',
  GET_BET_ODDS: 'getBetOdds',
  GET_AGENT_WALLET: 'getAgentWallet',
  GET_AGENT_ALL_WALLETS: 'getAgentAllWallets',
  GET_ALL_POSITIVE_AVAILABLE_WALLETS: 'getAllPositiveAvailableWallets',
  GET_SUB_AGENT_STATISTIC: 'getSubAgentStatistic',
  GET_PRODUCTS_LOG: 'getPartnerProductsLogs',
  GET_CARRY_OVER_LOG_LIST: 'getCarryOverLogByAffiliate',
  GET_WITHDRAW_SUB_USER_LIST: 'getWithdrawListForChildren',
  GET_WITHDRAW_ACTIVITY_LOGS: 'getWithdrawActivityLogs',
  GET_MY_REQUESTS_USER_LIST: 'getMyRequestsUserList',
  GET_COMMISSION_PLAN_LOG: 'getCommissionPlanLogs',
  CHECK_COMMISSION_USAGE: 'checkCommissionUsage',
  GET_AGENT_WALLET_BY_AGENT_ID: 'getAgentWalletByAgentId',
  GET_PLAYERS_TRANSFER_LIST: 'getPlayersTransferList',
  GET_AGENT_TRANSACTION_LIST: 'getAgentTransactionList',
  GET_AGENTS_TRANSFER_LIST: 'getAgentsTransferList',
  GET_PLAYERS_BALANCE_BY_ID: 'getPlayersBalanceById',
  GET_ALL_PRODUCTS: 'getAllProducts',
  GET_All_LANGUAGES: 'getAllLanguages',
  GET_ALL_CURRENCIES: 'getAllCurrencies',
  GET_AFFILIATE_PAYMENT_SYSTEMS: 'getAffiliatePaymentSystems',
  GET_AFFILIATE_DEFAULT_WITHDRAW: 'getDefaultWithdrawPayment',
  GET_AVAILABLE_BANNERS: 'getAvailableBanners',
  GET_MY_BANNERS: 'getMyBanners',
  GET_SUB_USER_BANNERS: 'getSubUserBanners',
  GET_ACTIVE_BANNERS: 'getActiveBanners',
  GET_PARTNER_BRANDS: 'getPartnerBrands',
  GET_MARKETING_SOURCES: 'getMarketingSourcesList',
  GET_LANDING_PAGES_LIST: 'getLandingPageList',
  GET_LINKS: 'getLinks',
  GET_SOCIAL_SHARE_LIST: 'getSocialShareList',
  GET_LATEST_NEWS: 'getLatestNews',
  GET_DELETED_PLAYERS_LIST: 'getDeletedPlayersList',
  GET_PLAYERS_STATISTICS_PRO_LIST: 'getActivePlayersList',
  GET_PLAYER_LIMIT: 'getPlayerLimit',
  TRANSFER_PLAYER_LOG: 'transferPlayerLog',
  GET_ADDED_PLAYERS_LIST: 'getAddedPlayersList',
  GET_GROUPS_LIST: 'getGroups',
  GET_AFFILIATES_LIST_BY_GROUP_ID: 'getUsersListByGroupId',
  GET_TESTIMONIALS: 'getTestimonials',
  GET_DOMAINS_URL: 'getDomainsURL',
  GET_ADDITIONAL_DOMAINS: 'getAdditionalDomains',
  GET_DOMAIN_NAMES: 'getDomainNames',
  GET_ALL_HYBRIDS: 'getAllHybrids',
  GET_FILE_HUB_LIST: 'getFileHubList',
  GET_PRODUCTS_COST_LOG: 'getProductsCostLog',
  GET_CURRENT_LANG_DICTIONARY_ITEM: 'getCurrentLangDictionaryItem',
  GET_PAYMENT_FTD_RESTRICTION: 'getFtdRestrictions',
  GET_PAYMENT_MIN_MAX_RANGE: 'getWithdrawalLimits',
  GET_AFFILIATE_COMMISSION: 'getCommissionByUser',
  GET_AFFILIATE_REFERRAL_COMMISSION: 'getReferralCommissionByUser',
  GET_COMMISSION_TYPE_NAMES: 'getCommissionTypeNames',
  GET_PARTNER_BONUS_COST: 'getPartnerBonusCost',
  GET_VERIFICATION_DOC: 'getVerificationDoc',
  GET_AFFILIATE_CHANGE_STATUS_LOGS: 'getAffiliateChangeStatusLogs',
  GET_COMMISSIONS: 'getCommission',
  GET_PARTNER_CARRY_OVER: 'getPartnerCarryOver',
  GET_AFFILIATE_CARRY_OVER: 'getAffiliateCarryOver',
  GET_COMMISSION_TYPE_BY_ID: 'getCommissionById',
  GET_HYBRIDS: 'getHybrids',
  GET_CPA: 'getCpa',
  GET_REFERRAL: 'getReferral',
  GET_AFFILIATE_PASSWORD_CHANGE_LOG: 'getAffiliatePasswordChangeLog',
  GET_PLAYER_PASSWORD_CHANGE_LOG: 'getPlayerPasswordChangeLog',
  GET_AFFILIATE_PERSONAL_INFO_LOG: 'getUserInfoLog',
  MESSAGES_CHATS: 'fetchChats',
  MESSAGES_CONVERSATION: 'fetchConversation',
  GET_TOTAL_UNREAD_MESSAGES_COUNT: 'getTotalUnreadMessagesCount',
  GET_UPLOADED_CORRECTION_LIST: 'getCorrectionByFileUsersList',
  GET_PLAYER_COMMISSION_PLAN_LOGS: 'getPlayerCommissionPlanLogs',
  GET_AFFILIATE_TAXES: 'getAffiliateTaxes',
  GET_TAXES_BY_GROUP: 'getTaxesByGroup',
  GET_CRON_LIST: 'getCronList',
  GET_POST_BACK_LIST: 'getPostBackData',
  GET_POST_BACK_BY_ID: 'getPostbackById',
  GET_LOYALTY_USERS_LIST: 'getLoyaltyUsersList',
  LOYALTY_GET_ITEMS: 'getItems',
  LOYALTY_GET_MISSIONS: 'getLoyaltyMissions',
  GET_LEVELS: 'getLevels',
  GET_PARTNER_REPORT: 'getPartnerReport',
  GET_POSTBACK_CHANGE_LOG: 'getPostbackChangeLog',
  GET_CONFIG_FOR_POSTBACK: 'getConfigPostback',
  GET_EDITABLE_PERMISSIONS_BY_ROLE: 'getEditablePermissionsByRole',
  GET_AVAILABLE_EDITABLE_PERMISSIONS_FOR_ROLE: 'getAvailableEditablePermissionsForRole',
  GET_AFFILIATE_PERMISSIONS: 'getUserPermissions',
  GET_EDITABLE_PERMISSIONS_FOR_AFFILIATE: 'getEditableUserPermissions',
  GET_FOOTER: 'getFooter',
  GET_TEMPLATE: 'getTemplates',
  GET_CORRECTION_LOG_STATISTICS: 'getCorrectionLogStatistics',
  GET_STATUS_CHANGE_LOG: 'getStatusChangeLog',
  GET_MARKETPLACE_STATUS_CHANGE_LOG: 'getMarketplaceStatusChangeLog',
  GET_CORRECTION_LOG: 'getCorrectionLog',
  GET_MISSIONS_DELETE_LOG: 'getMissionsDeleteLog',
  GET_WIDGETS_DATA: 'getWidgets',
  GET_SKINS_LIST: 'getSkinsList',
  GET_PERMISSION_LIST: 'getPermissionList',
  GET_PERMISSION_EDITABLE: 'getPermissionEditable',
  GET_PERMISSION_ROLES_TYPES: 'getPermissionsRolesTypes',
  GET_PERMISSION_FOR_ROLES: 'getPermissionForRoles',
  GET_PERMISSION_FUNCTIONS: 'getPermissionsFunctions',
  GET_FINANCIAL_REPORT: 'getFinancialReport',
  GET_SECONDARY_PARTNERS_LIST: 'getSecondaryPartnersList',
  GET_AFFILIATE_ACCESS_TOKENS_LIST: 'getAffiliateAccessTokensList',
  GET_SECONDARY_EMAIL: 'getSecondaryEmail',
  GET_PARTNER_SKIN_TYPE: 'getPartnerSkinType',
  GET_CONFIG: 'getConfig',
  GET_PARTNER_PERMISSION_BY_ID: 'getPartnerPermissionById',
  GET_PARTNERS_WIDGETS_DATA: 'getPartnersWidgetsData',
  GET_FINANCIAL_WIDGETS_DATA: 'getFinancialWidgetsData',
  GET_TRANSACTION_LIMITS_BY_AFFILIATE_ID: 'getTransactionLimitsByAffiliateId',
  GET_TRANSACTION_LIMITS_BY_ROLE: 'getTransactionLimitsByRole',
  GET_FIELD_LIST: 'getFieldList',
  GET_LOYALTY_GET_MISSIONS: 'getMission',
  GET_LOYALTY_GET_MISSIONS_HISTORY: 'getMissionsHistory',
  GET_LOYALTY_GET_MARKET_PLACE_ITEM: 'getMarketplaceItems',
  GET_LOYALTY_GET_MY_MARKET_PLACE_ITEM: 'getMyMarketplaceItems',
  GET_LOYALTY_COINS_AND_POINTS: 'getLoyaltyCoinsAndPoints',
};

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  tagTypes: Object.values(INVALIDATION_TAGS),
  endpoints: () => ({}),
});

export const feedApi = createApi({
  reducerPath: 'feedApi',
  baseQuery: fetchBaseQuery({ baseUrl: DATA_FEED_URL }),
  tagTypes: [],
  endpoints: () => ({}),
});
